// src/locales/ar/translation.ts
const ar = {
  app: {
    title: "مسابقة الأمن السيبراني",
    play: "إلعب",
    admin: "لوحة التحكم",
    scoreboard: "لوحة النتائج",
    joinGame: "إنضم إلى اللعبة",
    joinTeam: "إنضم إلى الفريق",
  },
  common: {
    welcomePlayer: "مرحبًا",
    chooseChallenge: "إختر تحديًا وابدأ اللعب.",
    gameCode: "رمز اللعبة: ",
    teamPoints: "نقاط الفريق",
    search: "البحث عن تحدي...",
    question: "؟",
    yes: "نعم",
    no: "لا",
  },
  actions: {
    submit: "إرسال",
    cancel: "إلغاء",
    start: "ابدأ",
    next: "التالي",
    back: "الرجوع",
    locked: "غير متاح",
    submitted: "تم التقديم",
  },
  play: {
    viewScoreboard: "النتائج",
    challengesTitle: "التحديات",
    filterByDifficulty: "تصفية حسب الصعوبة",
    filterByCategory: "تصفية حسب الفئة",
    noChallenges: "لا توجد تحديات متاحة.",
    categories: "فئات",
    category: "الفئة",
    allcategories: "جميع الفئات",
    nochallenges: "لا توجد أي تحديات",
    points: "نقطة ",
    duration: "دقائق",
  },
  difficulty: {
    difficulty: "الصعوبة",
    alldifficulties: "جميع الصعوبات",
    easy: "سهل",
    medium: "متوسط",
    hard: "صعب",
  },
  submitmodal: {
    //dev note: We may have duplicates now, which can be for diff functions. can be removed later or unified.
    submit: "قدِِم",
    launchChal: "ابدأ التحدي",
    hints: "تلميحات",
    flag: "العلم",
    revealHint: "كشف التلميح",
    revealHintText:
      "هذا الكشف سيكلف فريقك 15 نقطة(في حال تم الحل). هل تود الاستمرار؟ ",
    attachment: "المرفق",
  },
  login: {
    adminLoginTitle: "تسجيل الدخول",
    username: "اسم المستخدم",
    usernamePlaceholder: "اسم المستخدم",
    password: "كلمة المرور",
    passwordPlaceholder: "كلمة المرور",
    login: "تسجيل الدخول",
    returnToPlayer: "الرجوع إلى تسجيل الدخول",
    loginFailedTitle: "المصادقة فشلت",
    invalidCredentials: "فشل تسجيل الدخول. تحقق من صحة الإسم و كلمة المرور",
    loginFailedGeneric: "...",
  },
  submissiontoast: {
    missingflag: "العلم مفقود",
    plsFlag: "الرجاء ادخال العلم",
    wrongFlag: "العلم خاطئ",
    incorrectFlag: "العلم غير صحيح. يرجى المحاولة مرةً أخرى.",
    correctFlag: "!صحيح ",
    hintRevealed: "تم كشف التلميح",
    hintRevealedText: "! اقرأ جيداً",
    alreadyRevealed: "تم الكشف عنها بالفعل",
    alreadyRevealedText: "لقد استخدم فريقك هذا التلميح بالفعل",
    challengeCompleted: "تم اكمال التحدي. يرجى نحديث الصفحة",
    pointsBase: "+{{points}} نقطة",
    pointsBonus: "(+{{bonus}} نقطة إضافية)",
    pointsPenalty: "(-{{penalty}} خصم التلميح)",
    pointsTotal: "= +{{total}} نقطة",
  },
  sidetoast: {
    welcomeChallenge: "!🎉 تم اكمال الترحيب",
    welcomeChallengeText:
      " لقد أكملت المقدمة بنجاح. حميع التحديات الآن أصبحت متاحة",
    bonus: "!🏆 تم تحقيق المكافأة",
    firstSolve: "🏆 أول فريق يجتاز التحدي! (+20 مكافأة)",
    secondSolve: "🥈 الفريق الثاني الذي يجتاز التحدي! (+15 مكافأة)",
    thirdSolve: "🥉 الفريق الثالث الذي يجتاز التحدي! (+10 مكافأة)",
  },
  scoreboard: {
    livescoreboard: "لوحة النتائج المباشرة",
    refresh: "تحديث",
    backToPlay: "الرجوع للَّعب ",
    gamelabel: "اللعبة",
    leaders: "المتصدرون",
    top3: "أفضل 3 فرق من حيث النقاط",
    pts: "نقطة",
    solveSprint: "وتيرة الحلّ",
    solveText: "التحديات التي تم حلها لكل فريق",
    points: "نقاط",
    pointspt: "نقاط لكل فريق",
    allteams: "جميع الفرق",
    livept: "نقاط مباشرة لكل فريق",
    noteams: "لا فريق حتى الآن",
    team: "فريق",
    solves: "حلول",
    lastsolve: "آخر حل",
  },
  admin: {
    admindashboard: "لوحة التحكم",
    viewScoreboard: "لوحة النتائج",
    logout: "تسجيل الخروج",
    createGame: "إنشاء لعبة",
    code: "الرمز",
    createplholder: "مثال CTF2025-ROUND2",
    codeHint: "حروف وأرقام ونقطة وشرطة وشرطة سفلية فقط. بدون مسافات.",
    maxteamsize: "الحد الأقصى لحجم الفريق",
    duration: "المدة (بالدقائق)",
    status: "الحالة",
    lobby: "في الإنتظار",
    active: "نشطة",
    ended: "انتهت",
    selectTxt: "اختر التحديات",
    showing: "يُعرض:",
    allcategories: "جميع الفئات",
    available2: "المتاح:",
    available1: "متاح",
    selected: "مختار",
    create: "إنشاء",
    teams: "الفِرق",
    teamsTxt: "إدارة الفِرق للعبة المختارة",
    activeGame: "اللعبة الفعالة",
    selectGame: "اخر لعبة...",
    noGames: "لا لعبة حتى الآن",
    genReset: "إنشاء / إعادة",
    refresh: "تحديث",
    timer: "مؤقت",
    timerTxt: "إضغط إبدأ للبدأ",
    start: "إبدأ",
    end: "إنهاء",
    extend: "تمديد (بالدقائق)",
    numOfTeams: "عدد الفِرق",
    team: "فريق",
    joinLink: "رابط الانضمام",
    action: "إجراءات",
    teamTxt: "لا يوجد فِرق حالياً. اضغط إنشاء لتكوين الفِرق",
    selectTeamTxt: "إختر لعبة أولاً",
    noscore: "لا نتائج حالياً",
    open: "فتح",
    copy: "نسخ",
    save: "حفظ",
    pts: "نقطة",
    add1Minute: "+دقيقة",
    add5Minutes: "+5 دقائق",
    noPlayersYet: "لا يوجد لاعبون في هذا الفريق",
    gameControl: "التحكم باللعبة",
    gameControlTxt: "ابدأ اللعبة المختارة أو مدّدها أو أنهِها",
    deleteGame: "حذف اللعبة",
    pinnedFirst: "دائمًا في الأعلى: يحلّه اللاعبون لفتح بقية التحديات",
    endConfirmTitle: "إنهاء {{code}}؟",
    endConfirmBody: "ستنتهي اللعبة لجميع الفرق فورًا ولن يتمكن اللاعبون من إرسال الأعلام بعد ذلك. لا يمكن إعادة تشغيل لعبة منتهية.",
    endConfirmAccept: "إنهاء اللعبة",
    deleteConfirmTitle: "حذف {{code}}؟",
    deleteConfirmBody: "سيتم حذف اللعبة نهائيًا مع جميع فرقها ولاعبيها ونتائجها. تبقى التحديات نفسها محفوظة. لا يمكن التراجع عن هذا الإجراء.",
    deleteConfirmBodyLive: "هذه اللعبة لا تزال جارية. حذفها يوقفها لجميع اللاعبين فورًا ويحذف فرقها ولاعبيها ونتائجها نهائيًا. تبقى التحديات نفسها محفوظة. لا يمكن التراجع عن هذا الإجراء.",
    deleteConfirmAccept: "حذف اللعبة",
  },
  adminToasts: {
    gameCreated: 'لعبة "{{code}}" تم انشائها مع {{count}} تحدي / تحديات',
    gameCodeError: "رمز اللعبة مطلوب.",
    challengeError: "اختر تحدي واحد على الأقل.",
    failedGames: "فشل تحميل الألعاب",
    failedChallenges: "فشل تحميل التحديات",
    selectGame: "اختر لعبة أولاً",
    gameStarted: "بدأت اللعبة",
    startFailed: "فشل البدء",
    extendFailed: "فشل التمديد",
    extendedBy: "تم التمديد ب {{seconds}} ثانية.",
    gameEnded: "انتهت اللعبة",
    endFailed: "فشل الانتهاء",
    gameDeleted: 'تم حذف اللعبة "{{code}}".',
    createFailed: " فشل الإنشاء",
    requestFailed: "فشل الطلب",
    scoresRefreshed: "تمت إعادة تحميل النتائج",
    failScoreboard: "فشل تحميل لوحة النتائج",
    teamsRefresh: "تم تحديث الفِرق",
    failed: "فشل",
    teamEmpty: "لا يمكن أن يكون إسم الفريق فارغاً",
    updateFailed: "فشل التحديث",
    linkCopy: "تم نسخ الرابط بنجاح",
    success: "نجح",
    error: "خطأ",
    savedTeamName: "تم الحفظ بنجاح",
    teamsRefreshed: "تمت إعادة تحميل الفرق",
    generatedTeams: "تم إنشاء {{count}} فرق",
  },
  joinGame: {
    joinurTeam: "إنضم إلى فريقك",
    joinholder: "ألصق رابط الدعوة أو رمز الفريق",
    joinBtn: "إنضم",
    joinTip:
      "مهم: يمكنك لصق الرابط كاملاً أو الجزء الاخير منه /join/abcd123 أو الرمز فقط. ",
    joinError: "لا يبدو انه رابط دعوة أو رمز صحيح",
  },
  joinTeam: {
    join: "إنضم إلى ",
    joinTxt: "أدخل إسمك للإنضمام إلى الفريق و بدأ اللعب! ",
    yourName: "الإسم",
    joinholder: "أدخل إسمك",
    joinBtn: "إنضم",
    linkInvalid: "رابط غير صحيح",
    linkInvalidTxt: "لم يتم العثور على لعبة بهذا الرمز.",
    goHome: "الذهاب للصفحة الرئيسية",
  },
  status: {
    lobby: "في الإنتظار",
    active: "نشطة",
    ended: "انتهت",
  },
  errors: {
    generic: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    GAME_CODE_INVALID:
      "رمز اللعبة غير صالح. استخدم من {{min}} إلى {{max}} حرفًا: حروف وأرقام ونقاط وشرطات، بدون مسافات.",
    GAME_CODE_TAKEN: "توجد لعبة بالرمز \"{{code}}\" بالفعل. اختر رمزًا مختلفًا.",
    GAME_NOT_FOUND: "لم تعد هذه اللعبة موجودة. حدّث الصفحة واختر غيرها.",
    GAME_ALREADY_STARTED: "بدأت هذه اللعبة بالفعل، لذا لا يمكن تغيير إعداداتها.",
    MAX_TEAM_SIZE_INVALID: "يجب أن يكون حجم الفريق بين {{min}} و {{max}}.",
    DURATION_INVALID:
      "يجب أن تكون المدة بين {{minMinutes}} و {{maxMinutes}} دقيقة.",
    STATUS_INVALID: "حالة اللعبة غير صالحة.",
    NO_CHALLENGES_SELECTED: "أضف تحديًا واحدًا على الأقل قبل إنشاء اللعبة.",
    UNKNOWN_CHALLENGES:
      "بعض التحديات المختارة لم تعد موجودة. حدّث الصفحة واختر من جديد.",
    EXTEND_INVALID: "أدخل عدد الدقائق التي تريد إضافتها.",
    TEAM_COUNT_INVALID: "يجب أن يكون عدد الفرق بين {{min}} و {{max}}.",
    TEAM_NOT_FOUND: "لم يعد هذا الفريق ضمن هذه اللعبة.",
    TEAM_NAME_TOO_SHORT: "يجب أن يتكون الاسم من {{min}} حروف على الأقل.",
    TEAM_FULL: "هذا الفريق مكتمل. اطلب من المنظّم رابطًا آخر.",
    PLAYER_NAME_TAKEN: "هذا الاسم مستخدم بالفعل في هذا الفريق. جرّب اسمًا آخر.",
    JOIN_CODE_INVALID: "رابط الدعوة هذا غير صالح. تحقق منه مع المنظّم.",
  },
  ui: {
    brandSub: "تحدي التوعية",
    skipToContent: "تخطَّ إلى المحتوى",
    theme: "سمة الألوان",
    themeLight: "فاتح",
    themeDark: "داكن",
    switchLanguage: "تغيير اللغة",
    unknown: "غير معروف",
    notFoundTitle: "الصفحة غير موجودة",
    notFoundText:
      "هذا الرابط لا يؤدي إلى أي صفحة. تحقق من العنوان أو عُد إلى البداية.",
    noResults: "لا توجد نتائج مطابقة",
    noResultsText: "جرّب فئة أو مستوى صعوبة مختلفًا، أو امسح البحث.",
    clearFilters: "مسح عوامل التصفية",
    solvedCount: "تم حل {{solved}} من {{total}}",
    timeRemaining: "الوقت المتبقي",
    loadFailed: "تعذّر تحميل التحديات",
    retry: "إعادة المحاولة",
    solved: "تم الحل",
    selectAll: "تحديد الكل",
    live: "مباشر",
    reconnecting: "جارٍ إعادة الاتصال",
    clearAll: "مسح",
    dropHere: "اسحب التحديات إلى هنا، أو استخدم السهم في كل عنصر",
    nothingHere: "لا توجد نتائج مطابقة للبحث",
    lockedHint: "أكمل التحدي الأول لفتح بقية التحديات.",
    progress: "التقدم",
    attachments: "المرفقات",
    noTeamsYet: "لا توجد فرق بعد",
    noTeamsYetText: "أنشئ الفرق لتوليد روابط الانضمام للاعبين.",
    selectGameFirst: "اختر لعبة",
    selectGameFirstText: "اختر لعبة نشطة بالأعلى لإدارة فرقها ونتائجها.",
  },
};

export default ar;
